import { createAction } from '@reduxjs/toolkit';
import { GET_CONVERT_CART_FAILURE, GET_CONVERT_CART_REQUEST, GET_CONVERT_CART_SUCCESS, SET_ACTIVE_PREFER_DEALER, SET_AS_A_GUEST_EMAIL, SET_BILLING_ADDRESS_DATA, SET_BILLING_ADDRESS_FIELD_ERROR, SET_BILLING_OPTION, SET_CHECKOUT_LABELS, SET_CREATED_YAMAHA_ACCOUNT, SET_CURRENT_FORM_NAME, SET_CURRENT_STEP_NUMBER, SET_DEALER_LIST, SET_GOOGLE_KEY, SET_LOQATE_KEY, SET_ORDER_REVIEW_MODEL, SET_PAYMENT_SESSION, SET_PERSONAL_DETAILS_DATA, SET_PERSONAL_DETAILS_FIELD_ERROR, SET_PICK_UP_AT_DEALER_DISABLED, SET_SALUTATIONS, SET_SAME_AS_SHIPPING_ADDRESS, SET_SHIPPING_DETAILS_CONTINUE, SET_SHIPPING_DETAILS_DATA, SET_SHIPPING_DETAILS_EMAIL_ERROR, SET_SHIPPING_DETAILS_FIELD_ERROR, SET_DEALERS_TOOLS, SET_ORDER_REVIEW_STATUS, SET_ADDRESS_CONFIG, SET_PAYMENT_ERRORS, SET_PAYMENT_SUCCESS, SET_PAYMENT_PROVIDER, SET_BILLING_COUNTRIES, SET_BILLING_STATES, SET_CHECKOUT_LOGIN, SET_PAYEVER_CONFIG_MODEL, SET_BILLING_AND_DEALERS_ORDER, SET_EXCLUSION_POSTAL_CODE, } from './actionTypes';
export const setCheckoutLabels = createAction(SET_CHECKOUT_LABELS);
export const setAsGuestEmail = createAction(SET_AS_A_GUEST_EMAIL);
export const setCurrentStepNumber = createAction(SET_CURRENT_STEP_NUMBER);
export const setCurrentFormName = createAction(SET_CURRENT_FORM_NAME);
export const setActivePreferDealerId = createAction(SET_ACTIVE_PREFER_DEALER);
export const setSalutations = createAction(SET_SALUTATIONS);
export const setPersonalDetailsData = createAction(SET_PERSONAL_DETAILS_DATA);
export const setPersonalDetailsFieldErrors = createAction(SET_PERSONAL_DETAILS_FIELD_ERROR);
const setShippingDetailsContinue = createAction(SET_SHIPPING_DETAILS_CONTINUE);
export const setPickUpAtDealerDisabled = createAction(SET_PICK_UP_AT_DEALER_DISABLED);
export const setShippingDetailsData = createAction(SET_SHIPPING_DETAILS_DATA);
export const setShippingDetailsFieldErrors = createAction(SET_SHIPPING_DETAILS_FIELD_ERROR);
export const setLoqateKey = createAction(SET_LOQATE_KEY);
export const setCreatedYamahaAccount = createAction(SET_CREATED_YAMAHA_ACCOUNT);
export const setBillingAddressFieldErrors = createAction(SET_BILLING_ADDRESS_FIELD_ERROR);
export const setGoogleKey = createAction(SET_GOOGLE_KEY);
export const setDealerList = createAction(SET_DEALER_LIST);
export const getConvertCartRequest = createAction(GET_CONVERT_CART_REQUEST);
export const getConvertCartSuccess = createAction(GET_CONVERT_CART_SUCCESS);
export const getConvertCartFailure = createAction(GET_CONVERT_CART_FAILURE);
export const setOrderReviewModel = createAction(SET_ORDER_REVIEW_MODEL);
export const setBillingAddressData = createAction(SET_BILLING_ADDRESS_DATA);
export const setSameAsShippingAddress = createAction(SET_SAME_AS_SHIPPING_ADDRESS);
export const setShippingDetailsEmailError = createAction(SET_SHIPPING_DETAILS_EMAIL_ERROR);
export const setPaymentSession = createAction(SET_PAYMENT_SESSION);
const setPaymentSuccess = createAction(SET_PAYMENT_SUCCESS);
const setPaymentErrors = createAction(SET_PAYMENT_ERRORS);
export const setBillingOption = createAction(SET_BILLING_OPTION);
export const setDealersTools = createAction(SET_DEALERS_TOOLS);
export const setOrderReviewStatus = createAction(SET_ORDER_REVIEW_STATUS);
export const setAddressConfig = createAction(SET_ADDRESS_CONFIG);
export const setPaymentProvider = createAction(SET_PAYMENT_PROVIDER);
export const setBillingCountries = createAction(SET_BILLING_COUNTRIES);
export const setBillingStates = createAction(SET_BILLING_STATES);
export const setCheckoutLogin = createAction(SET_CHECKOUT_LOGIN);
export const setPayeverConfigModel = createAction(SET_PAYEVER_CONFIG_MODEL);
export const setIsBillingAndDealersSwapped = createAction(SET_BILLING_AND_DEALERS_ORDER);
export const setIsPostalCodeInExclusionList = createAction(SET_EXCLUSION_POSTAL_CODE);
export const actions = {
    activePreferDealerId: setActivePreferDealerId,
    asGuestEmail: setAsGuestEmail,
    billingAddressData: setBillingAddressData,
    billingAddressFieldErrors: setBillingAddressFieldErrors,
    billingOption: setBillingOption,
    checkoutLabels: setCheckoutLabels,
    convertCartFailure: getConvertCartFailure,
    convertCartRequest: getConvertCartRequest,
    convertCartSuccess: getConvertCartSuccess,
    createdYamahaAccount: setCreatedYamahaAccount,
    currentFormName: setCurrentFormName,
    currentStepNumber: setCurrentStepNumber,
    dealerList: setDealerList,
    googleKey: setGoogleKey,
    loqateKey: setLoqateKey,
    orderReviewModel: setOrderReviewModel,
    personalDetailsData: setPersonalDetailsData,
    personalDetailsErrors: setPersonalDetailsFieldErrors,
    isPickUpAtDealerDisabled: setPickUpAtDealerDisabled,
    salutations: setSalutations,
    sameAsShippingAddress: setSameAsShippingAddress,
    shippingDetailsContinue: setShippingDetailsContinue,
    shippingDetailsData: setShippingDetailsData,
    shippingDetailsEmailError: setShippingDetailsEmailError,
    shippingDetailsFieldsErrors: setShippingDetailsFieldErrors,
    setPayment: setPaymentSession,
    dealersTools: setDealersTools,
    orderReviewStatus: setOrderReviewStatus,
    paymentProvider: setPaymentProvider,
    payeverConfigModel: setPayeverConfigModel,
    setAddressConfig,
    setPaymentSuccess,
    setPaymentErrors,
    setBillingCountries,
    setBillingStates,
    setCheckoutLogin,
    setIsBillingAndDealersSwapped,
    setIsPostalCodeInExclusionList,
};
